let confirmHandler: ((message: string) => Promise<boolean>) | null = null;

export const setConfirmHandler = (
  handler: ((message: string) => Promise<boolean>) | null,
) => {
  confirmHandler = handler;
};

export const appConfirm = async (message: string): Promise<boolean> => {
  if (confirmHandler) return confirmHandler(message);
  return window.confirm(message);
};

